import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-421819ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "worp" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "付费功能不能与身份赋予、钉钉登录等功能功能同时使用。", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "不开启手机白名单，该设置不生效", -1))
const _hoisted_4 = { class: "worp_scroll" }
const _hoisted_5 = { class: "worp_swt" }

import { computed, getCurrentInstance, ref } from 'vue';
import { InputNumber, Radio, Modal, Table, Alert, Popover, message, notification } from 'ant-design-vue';
import { QuestionCircleFilled } from '@ant-design/icons-vue';
import { useStore } from 'vuex';
import http from '@/api/live';
import router from '@/router';
import { getToken } from '@/plugins/cookie';
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList';
import { useDebounce } from '@/hooks/useDebounce'; //防抖

interface IData {
  key: string;
  nameId: string;
  name: string;
  number: number;
  city: string;
  money: number;
  time: string;
}

//  授权观看  ===> 付费观看
const __default__ = { name: 'PayWatch' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const liveBroadcastingRoomId = router.currentRoute.value.params.studioId;
// console.log('id', liveBroadcastingRoomId);
const aInputNumber = InputNumber;
const aRadioGroup = Radio.Group;
const aModal = Modal;
const aTable = Table;
const aAlert = Alert;
const aPopover = Popover;
const visible = ref<boolean>(false);
const store = useStore();
const form = computed(() => store.state.authorizView.payView);
const checkPaySwitch = computed(() => store.state.authorizView.idView.idGiveSwitch);
const updateForm = (type: number) => {
  if (form.value.paySwitch) {
    message.destroy();
    if (!type) store.commit('authorizView/checkPaySwitch');
    store.commit('authorizView/updateChildSwitch');
  }
  store.commit('authorizView/updatePayForm', form.value);
};
const showLoading = ref<boolean>(false);
const pay = ref<IData[]>([]);
const listData = () => {
  const data = {
    studio_id: liveBroadcastingRoomId,
    page: 1,
    page_num: 5,
  };
  showLoading.value = true;
  http
    .getPayList({ params: data })
    .then((res) => {
      if (res.data.data.data) {
        pay.value = res.data.data.data;
      } else pay.value = [];
      showLoading.value = false;
    })
    .catch((err) => {
      showLoading.value = false;
    });
};
// listData();
const columns = [
  {
    title: '观众ID',
    dataIndex: 'user_id',
    width: '120px',
    align: 'center',
  },
  {
    title: '观众名',
    dataIndex: 'ch_name',
    align: 'center',
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
    align: 'center',
  },
  {
    title: '访问地区',
    dataIndex: 'addr',
    align: 'center',
  },
  {
    title: '付款金额',
    dataIndex: 'payment_amount',
    align: 'center',
  },
  {
    title: '付款时间',
    dataIndex: 'updated_at',
    align: 'center',
  },
];
const showModal = () => {
  visible.value = true;
  listData();
};
// 导出
const { proxy }: any = getCurrentInstance();
const token = getToken();
const corn = ref(1);
const messageTip = ref();
const handleOk = useDebounce((e: MouseEvent) => {
  visible.value = false;
  const data = {
    studio_id: liveBroadcastingRoomId,
    type: 11,
    is_cron_download: corn.value,
  };
  https
    .excel_regional_distribution({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(aAlert), {
        message: "开启付费观看后，需要付费后才能进入频道观看直播",
        type: "warning",
        "show-icon": ""
      }),
      _createElementVNode("div", null, [
        _createTextVNode(" 金额设置： "),
        _createVNode(_unref(aInputNumber), {
          id: "inputNumber",
          value: _unref(form).price,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).price) = $event)),
          min: 0,
          step: 0.01,
          size: "small",
          class: "worp_mount",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (updateForm(1)))
        }, null, 8, ["value", "step"]),
        _createTextVNode("元    "),
        _createVNode(_unref(aPopover), { placement: "rightTop" }, {
          content: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createTextVNode("提示文字："),
        _createVNode(_component_a_input, {
          value: _unref(form).text,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).text) = $event)),
          placeholder: "请输入文字",
          class: "worp_font",
          onInput: _cache[3] || (_cache[3] = ($event: any) => (updateForm(2)))
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(" 手机白名单验证成功后绕过付费： "),
        _createVNode(_unref(aRadioGroup), {
          value: _unref(form).isPhonebypass,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).isPhonebypass) = $event)),
          class: "worp_sel",
          onInput: _cache[5] || (_cache[5] = ($event: any) => (updateForm(3)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio, { value: true }, {
              default: _withCtx(() => [
                _createTextVNode("开启")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio, { value: false }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_unref(aPopover), { placement: "right" }, {
          content: _withCtx(() => [
            _hoisted_3
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(" 通过观看券链接进入绕过付费： "),
        _createVNode(_unref(aRadioGroup), {
          value: _unref(form).isInvitebypass,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).isInvitebypass) = $event)),
          class: "worp_sel",
          onInput: _cache[7] || (_cache[7] = ($event: any) => (updateForm(4)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio, { value: true }, {
              default: _withCtx(() => [
                _createTextVNode("开启")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio, { value: false }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createVNode(_component_a_button, {
        type: "link",
        onClick: showModal,
        class: "worp_foot"
      }, {
        default: _withCtx(() => [
          _createTextVNode("查看付费记录")
        ]),
        _: 1
      }),
      _createVNode(_unref(aModal), {
        visible: visible.value,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((visible).value = $event)),
        title: "付费记录",
        width: "806px",
        cancelText: " ",
        okText: " ",
        centered: "",
        onOk: _unref(handleOk)
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_a_button, {
            class: "mod_modal_btn mod_type_primary",
            onClick: _unref(handleOk)
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(aTable), {
              loading: showLoading.value,
              columns: columns,
              "data-source": pay.value,
              pagination: false,
              "row-key": "id"
            }, null, 8, ["loading", "data-source"])
          ])
        ]),
        _: 1
      }, 8, ["visible", "onOk"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createTextVNode(" 功能开关： "),
      _createVNode(_component_a_switch, {
        checked: _unref(form).paySwitch,
        "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).paySwitch) = $event)),
        onChange: _cache[10] || (_cache[10] = ($event: any) => (updateForm(0))),
        disabled: _unref(checkPaySwitch)
      }, null, 8, ["checked", "disabled"])
    ])
  ], 64))
}
}

})